import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LoginComponent } from './pages/login/login.component';
import { LlamadosComponent } from './pages/llamados/llamados.component';
import { IndexComponent } from './pages/index/index.component';

import { AuthGuard } from './core/guards/auth.guard';
import { ValidateGuard } from './core/guards/validate.guard';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'index' },
  { path: 'index', component: IndexComponent },
  { path: ':id', component: IndexComponent },
  { path: ':slug/login', component: LoginComponent, canActivate: [ValidateGuard] },
  { path: ':slug/llamados',  component: LlamadosComponent, canActivate: [AuthGuard] },
]; 

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
